module.exports = __webpack_public_path__ + "static/media/18ECA2.b1fb0ae4.jpg";